// extracted by mini-css-extract-plugin
export default {"container":"_Jp4hI","info":"SH9nJP","body":"qgYOGA","note":"bn6T40","benefits":"fiPMSP","buttonContainer":"qjCqka"};